import { MODAL_CLOSED, MODAL_OPEN, THEME_CART_UPDATED } from 'events';
import debounce from 'lodash/debounce';
import { component } from 'picoapp';
import Swiper, { Autoplay } from 'swiper';

Swiper.use([Autoplay]);

export default component((node, ctx) => {
  let activeIndex = 0;

  const { cart: initialCart } = ctx.getState();

  let itemCount = initialCart.item_count;
  let autoplayStarted = false;

  const carousel = new Swiper(node, {
    slidesPerView: 'auto',
    enabled: node.dataset.enabled === 'true',
    loop: true,
    speed: parseInt(node.dataset.speed || 1000, 10),
    autoplay:
      node.dataset.autoplay === 'true'
        ? {
            disableOnInteraction: false,
            delay: parseInt(node.dataset.delay || 1000, 10),
          }
        : false,
    on: {
      slideChange(s) {
        if (s.autoplay.running === false) return;

        activeIndex = s.realIndex;
      },
    },
  });

  const startAutoplay = debounce(() => {
    carousel.autoplay.start();
    carousel.activeIndex = activeIndex;
    carousel.update();

    autoplayStarted = true;
  }, 200);

  const stopAutoplay = () => {
    carousel.autoplay.stop();

    autoplayStarted = false;
  };

  ctx.on(MODAL_CLOSED, (state, { id }) => {
    if (id !== 'cart') return;

    stopAutoplay();
  });

  ctx.on(MODAL_OPEN, (state, { id }) => {
    if (id !== 'cart' || itemCount === 0) return;

    startAutoplay();
  });

  ctx.on(THEME_CART_UPDATED, ({ cart }) => {
    if (autoplayStarted) return;

    itemCount = cart.item_count;

    startAutoplay();
  });
});
